/* Split hero text rotator: heading / description / CTA groups advance together every 3.5 s; dots and swipe. */
(function () {
  document.querySelectorAll('.split-hero-section').forEach(function (section) {
    var groups = section.querySelectorAll('.slider-group'); if (!groups.length) return;
    var slides = Array.prototype.map.call(groups, function (g) { return g.querySelectorAll('.slide-element'); });
    var count = slides[0].length; if (count < 2) return;
    var dots = section.querySelectorAll('.slider-dot'); var i = 0, timer;
    function show(n) {
      var old = i; i = n;
      slides.forEach(function (list) {
        if (list[old]) { list[old].classList.remove('active'); list[old].classList.add('exiting'); hide(list[old], true); }
        if (list[i]) { list[i].classList.add('active'); hide(list[i], false); }
      });
      dots.forEach(function (d, k) { d.classList.toggle('active', k === i); if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      setTimeout(function () { slides.forEach(function (list) { if (list[old]) list[old].classList.remove('exiting'); }); }, 800);
    }
    /* §10S item 14 (2026-09-29): a slide that is not showing leaves the Tab order and the screen reader (inert),
       and its link gets tabindex -1 for browsers without inert. */
    function hide(el, off) {
      if (off) { el.setAttribute('inert', ''); el.setAttribute('aria-hidden', 'true'); } else { el.removeAttribute('inert'); el.removeAttribute('aria-hidden'); }
      el.querySelectorAll('a, button').forEach(function (a) { if (off) a.setAttribute('tabindex', '-1'); else a.removeAttribute('tabindex'); });
    }
    function start() { clearInterval(timer); timer = setInterval(function () { show((i + 1) % count); }, 3500); }
    dots.forEach(function (d) { d.addEventListener('click', function () { var n = +d.dataset.index; if (n !== i) { show(n); start(); } }); });
    var x0 = 0;
    section.addEventListener('touchstart', function (e) { x0 = e.changedTouches[0].screenX; }, { passive: true });
    section.addEventListener('touchend', function (e) { var dx = x0 - e.changedTouches[0].screenX; if (Math.abs(dx) > 50) { show(dx > 0 ? (i + 1) % count : (i - 1 + count) % count); start(); } }, { passive: true });
    document.addEventListener('visibilitychange', function () { document.hidden ? clearInterval(timer) : start(); });
    start();
  });
})();
